import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Master the power, cooling and operations behind mission-critical data centers. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nw2e2bl1k0tq">
      <MetaPixel data-id="element-1" data-mp="stuczpk3sn7f" />
      <main data-id="element-2" data-mp="stc7s3fgqynd">
        <Hero data-id="element-3" data-mp="ssspumptca9c" />
        <LookInsideCarousel data-id="element-4" data-mp="swqbbezv5dwe" />
        <ProblemSection data-id="element-5" data-mp="3688dot76uy6" />
        <SystemSection data-id="element-6" data-mp="35gm54lhq9kk" />
        <ModulesSection data-id="element-7" data-mp="34napqbl6vw3" />
        <BonusSection data-id="element-8" data-mp="38b2ajxh1886" />
        <UrgencySection data-id="element-9" data-mp="3udaw269tuj3n" />
        <PricingSection data-id="element-10" data-mp="3ubzt28o7hfdl" />
        <GuaranteeSection data-id="element-11" data-mp="3ucje3y95kjvu" />
        <FAQ data-id="element-12" data-mp="d4nv7fl6zi1v" />
        <ClosingSection data-id="element-13" data-mp="d57hf8hvkslp" />
        <SummaryTable data-id="element-14" data-mp="d3mi75km8lhi" />
        <FinalCta data-id="element-15" data-mp="d3wbp34vdary" />
      </main>
      <Footer data-id="element-16" data-mp="85l1granwy97" />
      <PurchaseNotification data-id="element-17" data-mp="851lvh8hilyc" />
    </div>;
}